import React from 'react';
import Select from 'react-select';
import './styles/leadKilderOgNoter.css';

const LEAD_SOURCES = [
  { value: 'linkedin', label: 'LinkedIn', icon: '💼' },
  { value: 'leadmagnet', label: 'Leadmagnet', icon: '🧲' },
  { value: 'coldCall', label: 'Cold Call', icon: '📞' },
  { value: 'ads', label: 'Ads', icon: '📣' },
  { value: 'referral', label: 'Referral', icon: '👥' },
  { value: 'website', label: 'Website', icon: '🌐' },
  { value: 'other', label: 'Other', icon: '📌' }
];

const CustomOption = ({ children, ...props }) => {
  const { data } = props;
  return (
    <div
      {...props.innerProps}
      className={`crm-sources__option ${props.isFocused ? 'crm-sources__option--is-focused' : ''} ${props.isSelected ? 'crm-sources__option--is-selected' : ''}`}
    >
      <span className="crm-sources__option-icon">{data.icon}</span>
      {children}
    </div>
  );
};

const CustomMultiValue = ({ children, ...props }) => {
  const { data } = props;
  return (
    <div className="crm-sources__multi-value">
      <span className="crm-sources__value-icon">{data.icon}</span>
      <span className="crm-sources__value-label">{children}</span>
    </div>
  );
};

const LeadKilderOgNoter = ({ formData, handleChange, handleArrayChange }) => {
  return (
    <div className="form-section crm-sources">
      <div className="section-header">
        <div className="header-title">
          <span className="section-icon">🎯</span>
          <div>
            <h3>Lead kilder & Noter</h3>
            <div className="section-description">
              Hvor kommer kunden fra og andre relevante noter
            </div>
          </div>
        </div>
      </div>

      <div className="crm-sources__content">
        <div className="crm-sources__group">
          <label className="crm-sources__label">Lead Sources</label>
          <Select
            isMulti
            name="leadSources"
            options={LEAD_SOURCES}
            value={LEAD_SOURCES.filter(s => formData.leadSources?.includes(s.value))}
            onChange={(selected) => {
              const values = selected ? selected.map(item => item.value) : [];
              handleArrayChange('leadSources', values);
            }}
            components={{
              Option: CustomOption,
              MultiValue: CustomMultiValue,
              ClearIndicator: () => null,
              IndicatorSeparator: () => null
            }}
            className="crm-sources__select-container"
            classNamePrefix="crm-sources"
            placeholder="Vælg lead sources..."
            noOptionsMessage={() => "Ingen lead sources fundet"}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isSearchable={true}
            menuPlacement="auto"
          />
        </div>

        <div className="crm-sources__group">
          <label className="crm-sources__label">Noter</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            className="crm-sources__notes"
            placeholder="Tilføj noter om kunden..."
          />
        </div>
      </div>
    </div>
  );
};

export default LeadKilderOgNoter;
